// angular
//     .module("HeroPRO")
//     .factory("POSignFactory", POSignFactory);

/* @ngInject */
export default function POSignFactory($http, HPConfig) {
    return {
        getPOInfo,
        emailPO,
    };

    function getPOInfo(id) {
        return $http.get(`${HPConfig.heroProApi}ESign/GetPropertyOwnerSignatures?FundingRequestId=${id}`);
    }

    function emailPO(id, po) {
        return $http.post(`${HPConfig.heroProApi}ESign/EmailPropertyOwnerSignDocsEnvelope`, {
            FundingRequestId: id,
            EDocumentRecipientId: po.Owner.EDocumentRecipientID,
            DocumentType: 'FinancingDocs',
            Email: po.Owner.Email,
            OwnerOrdinal: po.Owner.OrdinalInRole,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/startWork/PO-Sign/POSignFactory.js